import { EMPTY_HOUR } from '../../../shared/utils/constants';

const validate = (values) => {
  const errors = {};
  if (!values.student) {
    errors.student = 'Selecione um aluno';
  }

  if (!values.name) {
    errors.name = 'Digite o nome do medicamento';
  }

  if (!values.dosage) {
    errors.dosage = 'Digite a dosagagem do medicamento';
  }

  if (!values.routeAdministration) {
    errors.routeAdministration = 'Digite a via de administração';
  }

  if (!values.initialDate) {
    errors.initialDate = 'Informe a data inicial';
  }

  if (!values.finalDate) {
    errors.finalDate = 'Informe a data final';
  }

  if (!values.hour01) {
    errors.hour01 = 'Informe o horário 01 do medicamento';
  } else if (
    values.hour01 < values.startTime ||
    values.hour01 > values.finalTime
  ) {
    errors.hour01 = 'Digite uma hora dentro do período de funcionamento';
  }

  if (
    (values.hour02 &&
      values.hour02 !== EMPTY_HOUR &&
      values.hour02 < values.startTime) ||
    values.hour02 > values.finalTime
  ) {
    errors.hour02 = 'Digite uma hora dentro do período de funcionamento';
  }
  if (
    (values.hour03 &&
      values.hour03 !== EMPTY_HOUR &&
      values.hour03 < values.startTime) ||
    values.hour03 > values.finalTime
  ) {
    errors.hour03 = 'Digite uma hora dentro do período de funcionamento';
  }
  if (
    (values.hour04 &&
      values.hour04 !== EMPTY_HOUR &&
      values.hour04 < values.startTime) ||
    values.hour04 > values.finalTime
  ) {
    errors.hour04 = 'Digite uma hora dentro do período de funcionamento';
  }
  if (
    (values.hour05 &&
      values.hour05 !== EMPTY_HOUR &&
      values.hour05 < values.startTime) ||
    values.hour05 > values.finalTime
  ) {
    errors.hour05 = 'Digite uma hora dentro do período de funcionamento';
  }

  return errors;
};

export default validate;
